import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import { CrossCircleIcon } from "../../components/Icons";
import { S3ProviderListOutputItem } from "@aws-amplify/storage";
import { formatDateTime } from "../../utils/DateUtils";

type ModalProps = {
    showModal: boolean;
    setShowModale: (bool: boolean) => void;
};

/**
 * S3のファイルアップロード確認モーダル
 *
 * @param ModalProps
 * @returns JSX.Element
 */
const S3FileUploadConfirmModal: React.FC<ModalProps> = ({ showModal, setShowModale }) => {
    const { t } = useTranslation();

    return (
        <Modal
            className="fixed left-1/2 top-1/2 w-10/12 max-w-3xl -translate-x-1/2 -translate-y-1/2 transform whitespace-pre-wrap break-words rounded-lg border bg-white p-4 shadow-md"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50"
            isOpen={showModal}
        >
            <div className="m-0 px-4 py-2 sm:m-2">
                <div className="font-bold">{t("DataManagement.uploadeNoteTitle1")}</div>
                <hr className="my-2 border-t-2"></hr>

                <ul className="list-disc pb-6 pl-4 text-gray-800">
                    <li className="py-0.5">{t("DataManagement.uploadNote1")}</li>
                    <ul className="pb-1 pl-2 text-gray-800">
                        <li className="text-sm">{t("DataManagement.allowedExt1")}</li>
                        <li className="text-sm">{t("DataManagement.allowedExt2")}</li>
                        <li className="text-sm">{t("DataManagement.allowedExt3")}</li>
                    </ul>
                </ul>

                <div className="font-bold">{t("DataManagement.uploadeNoteTitle2")}</div>
                <hr className="my-2 border-t-2"></hr>

                <ul className="list-disc pb-4 pl-4 text-gray-800">
                    <li className="py-0.5">{t("DataManagement.uploadNote2")}</li>
                    <li className="py-0.5">{t("DataManagement.uploadNote3")}</li>
                    <li className="py-0.5">{t("DataManagement.uploadNote4")}</li>
                </ul>

                {/* 閉じるボタン */}
                <div className="mt-4 flex items-center justify-evenly">
                    <button className="btn-primary w-1/3" onClick={() => setShowModale(false)}>
                        {t("CommonLabel.close")}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default S3FileUploadConfirmModal;
